import message from '../../_constants/Message'

/**
 * @function getMessage メッセージを管理
 * @typedef {keyof message} messageIdType
 * @param {messageIdType} messageId
 */
export const getMessage = (messageId, ...args) => {
  let rtnMessage = message[messageId]
  args.forEach((value, index) => {
    rtnMessage = rtnMessage.replace('{' + index + '}', value)
  })
  return rtnMessage
}
